import { externalUploadPoller } from '@ff-os/pdp-shared-redux/apis/external-upload/externalUploaderPoller';
import { GiftPdpStore } from '@ff-scene-plugins/gift-redux/store';
import { createExternalUploadPollListener } from './createExternalUploadPollListener';
import { preprocess } from './preprocess';
import { registerArErrorHandler } from './registerArErrorHandler';
import { registerVariablePlugins } from './registerVariablePlugins';
import { startBlobUrlGarbageCollector } from './startBlobUrlGarbageCollector';
import { subscribe } from './subscribe';

export const startup = (store: GiftPdpStore): void => {
    registerVariablePlugins();
    preprocess(store);
    subscribe(store);
    startBlobUrlGarbageCollector(store);
    externalUploadPoller.addPollListener(createExternalUploadPollListener(store));
    registerArErrorHandler(store);
};